import routes from '@/modules/dashboard/routes'
import store from '@/modules/dashboard/store'

export default { routes, store }
